import GetAllNews from './dto/GetAllNews'
import axios from 'axios'
import { PagedFilterAndSortedRequest } from './dto/PagedFilterAndSortedRequest'
import { PagedResultDto } from '../../../services/dto/pagedResultDto'
import GetAllJobs from './dto/GetAllJobs'
import GetAllCompanies from './dto/GetAllCompanies'
import GetCompanyStatistic from './dto/GetCompanyStatistic'
import GetJobStatistic from './dto/GetJobStatistic'
const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_NEWS_DASHBOARD_GET_ALL = `${API_URL}/News/GetPagedAll`
export const URL_JOBS_DASHBOARD_GET_ALL = `${API_URL}/Job/GetPagedAllForGraduates`
export const URL_JOB_CONFIRMATIONS_DASHBOARD_GET_ALL = `${API_URL}/Job/GetPagedAll`
export const URL_GET_ALL = `${API_URL}/Company/GetPagedAll`
export const URL_GET_COMPANY_STATISTIC = `${API_URL}/Company/GetStatistic`
export const URL_GET_JOB_STATISTIC = `${API_URL}/Job/GetStatistic`

export function onGetPagedAllNews(
    pagedFilterAndSortedRequest: PagedFilterAndSortedRequest
): Promise<PagedResultDto<GetAllNews>> {
    return axios.get(URL_NEWS_DASHBOARD_GET_ALL, { params: pagedFilterAndSortedRequest })
}

export function onGetPagedAllJobs(
    pagedFilterAndSortedRequest: PagedFilterAndSortedRequest
): Promise<PagedResultDto<GetAllJobs>> {
    return axios.get(URL_JOBS_DASHBOARD_GET_ALL, { params: pagedFilterAndSortedRequest })
}

export function onGetPagedAllJobsForGraduates(
    pagedFilterAndSortedRequest: PagedFilterAndSortedRequest
): Promise<PagedResultDto<GetAllJobs>> {
    return axios.get(URL_JOB_CONFIRMATIONS_DASHBOARD_GET_ALL, { params: pagedFilterAndSortedRequest })
}
export function onGetJobStatistic(): Promise<GetJobStatistic[]> {
    return axios.get(URL_GET_JOB_STATISTIC)
}

export function onGetCompanyStatistic(): Promise<GetCompanyStatistic[]> {
    return axios.get(URL_GET_COMPANY_STATISTIC)
}

export function onGetPagedAllCompanies(
    pagedFilterAndSortedRequest: PagedFilterAndSortedRequest
): Promise<PagedResultDto<GetAllCompanies>> {
    return axios.get(URL_GET_ALL, { params: pagedFilterAndSortedRequest })
}